// extracted by mini-css-extract-plugin
module.exports = {"footer":"DefaultFooter_footer__2UQcq","row-visa":"DefaultFooter_row-visa__3FGLb"};